import styles from "./SettingsTable.module.css";

const { SettingsTableTableNote, SettingsTableCheckboxNote } = styles;

export { SettingsTableTableNote, SettingsTableCheckboxNote };

export * from "./SettingsTable";
